import React from 'react';
import { useFormikContext } from 'formik';

import './FormikFieldError.scss';

export interface FormikFieldErrorProps {
  name: string;
  displayIfNotTouched?: boolean;
}

const FormikFieldError = ({ name, displayIfNotTouched }: FormikFieldErrorProps) => {
  const { getFieldMeta } = useFormikContext();

  const { error, touched } = getFieldMeta(name);

  const hasError = Boolean(error && error !== '' && (touched || displayIfNotTouched));

  if (!hasError) {
    return null;
  }

  return <div className="enkrateia-form-field-error">{error}</div>;
};

export default FormikFieldError;
